import { Storefront } from '@phosphor-icons/react';
import { TASK_TYPES, type TaskType } from '@mybusinessmate/schema';
import { TASK_TYPE_META } from '../../lib/task-display';
import { ChoiceTile } from '../ui/choice-tile';

/**
 * Step 1 of the new-task page (Figma A05.3: "What kind of task?"). The design also has per-plan usage under each
 * tile ("5 of 8 used"); plan allowances are not exposed by the API yet. TODO(api).
 */
/** The line under a tile. TODO(api): "5 of 8 used" per plan needs billing; only what holds for every plan is said. */
const HINT: Partial<Record<TaskType, string>> = { website: 'One-off', custom: 'Anything else' };

export function TaskTypePicker({
  value,
  onChange,
  locked = false,
  step,
}: {
  value: TaskType;
  onChange: (type: TaskType) => void;
  /** A draft's type cannot change after it is created. */
  locked?: boolean;
  /** The step number shown in front of the title. */
  step?: number;
}) {
  return (
    <fieldset className="flex flex-col gap-(--mbm-space-3)">
      <legend className="flex items-center gap-(--mbm-space-2-5) text-heading-h3 text-text-primary">
        {step ? (
          <span
            aria-hidden
            className="flex size-(--mbm-size-avatar-xxs) items-center justify-center rounded-full bg-action-primary text-label-small text-text-on-dark"
          >
            {step}
          </span>
        ) : null}
        What kind of task?
      </legend>
      <div className="grid grid-cols-2 gap-(--mbm-space-3) sm:grid-cols-3 lg:grid-cols-6">
        {TASK_TYPES.map((type) => (
          <ChoiceTile
            key={type}
            icon={TASK_TYPE_META[type].icon}
            label={TASK_TYPE_META[type].label}
            hint={HINT[type]}
            selected={type === value}
            disabled={locked && type !== value}
            onSelect={() => onChange(type)}
          />
        ))}
        {/* TODO(api): "Google profile" has no value in `task_type_enum` (and no brief table) yet. */}
        <ChoiceTile icon={Storefront} label="Google profile" hint="Coming soon" disabled onSelect={() => {}} />
      </div>
    </fieldset>
  );
}
